/* eslint-disable @typescript-eslint/no-unnecessary-condition */
// Ignored because watchedCodes[1] ?? '' can be null
import { Flex, FormControl, Input } from '@chakra-ui/react';
import { AutoUpdateWrapper } from '@texas/components/shared/autoUpdate/useAutoUpdateForm';
import { ErrorLabel } from '@texas/components/shared/ErrorLabel';
import { FormCounter } from '@texas/components/shared/form/FormCounter';
import { useActiveContext } from '@texas/hooks/useActiveContext';
import { GarpFormContext } from '../SetGarpDataModal';
import { useWatch } from 'react-hook-form';
import { textMaxLength } from '@texas/api/endpoints/erp/garpApi';
import { useTranslation } from 'react-i18next';

export function GarpTextField({ textIndex }: { textIndex: number }) {
  const { register, triggerSubmit, registerAutoUpdate, control, formState } =
    useActiveContext(GarpFormContext);
  const { t } = useTranslation();

  const watchedCodes = useWatch({
    control,
    name: [`texts.${textIndex}.text`, `texts.${textIndex}.languageCode`],
  });

  return (
    <Flex gap={1}>
      <AutoUpdateWrapper
        autoUpdateProps={registerAutoUpdate}
        path={`texts.${textIndex}.languageCode`}
        boxProps={{ w: '30%' }}
      >
        <FormControl>
          <Input
            {...register(`texts.${textIndex}.languageCode`, {
              onBlur: triggerSubmit,
              maxLength: {
                value: 1,
                message: t('errors.maxLength', { count: 1 }),
              },
            })}
            variant="texas"
            maxLength={1}
          />
          <FormCounter length={(watchedCodes[1] ?? '').length} maxLength={1} />
          <ErrorLabel
            text={formState.errors.texts?.[textIndex]?.languageCode?.message}
          />
        </FormControl>
      </AutoUpdateWrapper>
      <AutoUpdateWrapper
        autoUpdateProps={registerAutoUpdate}
        path={`texts.${textIndex}.text`}
        boxProps={{ flexGrow: '1' }}
      >
        <FormControl>
          <Input
            {...register(`texts.${textIndex}.text`, {
              onBlur: triggerSubmit,
              maxLength: {
                value: textMaxLength,
                message: t('errors.maxLength', { count: textMaxLength }),
              },
            })}
            variant="texas"
            maxLength={textMaxLength}
          />
          <FormCounter
            length={(watchedCodes[0] ?? '').length}
            maxLength={textMaxLength}
          />
          <ErrorLabel
            text={formState.errors.texts?.[textIndex]?.text?.message}
          />
        </FormControl>
      </AutoUpdateWrapper>
    </Flex>
  );
}
